module.exports = __webpack_public_path__ + "media/images/redesign-images/backgrounds/bg-wave-f4d10bd76a938ba8d72f4f611084b15f.svg";